import { apiRequest } from './client';
import type { Call, CallCreate, CallDetail, CallUpdate, AgendaItemCreate, AgendaItemOut } from './types';

export async function listCalls(filter: 'active' | 'archived' | 'all' = 'active'): Promise<Call[]> {
  const archived = filter === 'active' ? 'false' : filter === 'archived' ? 'true' : 'all';
  return apiRequest<Call[]>(`/calls?archived=${archived}`);
}

export async function getCall(id: number): Promise<CallDetail> {
  return apiRequest<CallDetail>(`/calls/${id}`);
}

export async function createCall(payload: CallCreate): Promise<CallDetail> {
  return apiRequest<CallDetail>('/calls', { method: 'POST', body: payload });
}

export async function updateCall(id: number, payload: CallUpdate): Promise<CallDetail> {
  return apiRequest<CallDetail>(`/calls/${id}`, { method: 'PATCH', body: payload });
}

export async function deleteCall(id: number): Promise<void> {
  await apiRequest(`/calls/${id}`, { method: 'DELETE' });
}

export async function createCallItem(callId: number, payload: AgendaItemCreate): Promise<AgendaItemOut> {
  return apiRequest<AgendaItemOut>(`/calls/${callId}/items`, { method: 'POST', body: payload });
}
